// 本文の画像をクリックしたら暗い背景で大きく見られるようにする。
// 対象は本文だけ (.e-content の中)。ページ下部の抜粋は .markdown-body だが
// .e-content の外なので、めくり列には混ざらない。
// リンクカードのサムネは写真ではなくリンクの顔なので、拡大の列からは外す。
const SELECTOR = '.e-content img:not(.link-card-image)'

let overlay = null
let elements = {}
let images = []
let index = 0
let opener = null

export function setupLightbox() {
  images = Array.from(document.querySelectorAll(SELECTOR))
  if (images.length === 0) return

  images.forEach((image, i) => {
    image.addEventListener('click', (event) => {
      // リンクで包まれた画像でも、遷移よりは拡大を優先する
      event.preventDefault()
      open(i)
    })
  })

  document.addEventListener('keydown', onKeydown)
}

function build() {
  overlay = document.createElement('div')
  overlay.className = 'lightbox'
  overlay.hidden = true
  // Escや矢印を受けるためにフォーカスを預かる。閉じるボタンに預けると
  // マウスで開いただけでフォーカスリングが出てしまう。
  overlay.tabIndex = -1
  overlay.innerHTML = `
    <button type="button" class="lightbox-close" aria-label="Close">&times;</button>
    <button type="button" class="lightbox-nav lightbox-prev" aria-label="Previous">&#9664;</button>
    <img class="lightbox-image" alt="">
    <button type="button" class="lightbox-nav lightbox-next" aria-label="Next">&#9654;</button>
    <div class="lightbox-counter"></div>
  `

  elements = {
    image: overlay.querySelector('.lightbox-image'),
    prev: overlay.querySelector('.lightbox-prev'),
    next: overlay.querySelector('.lightbox-next'),
    counter: overlay.querySelector('.lightbox-counter'),
  }

  // 背景の余白を押したときだけ閉じる。画像そのものを押しても閉じない。
  overlay.addEventListener('click', (event) => { if (event.target === overlay) close() })
  overlay.querySelector('.lightbox-close').addEventListener('click', close)
  elements.prev.addEventListener('click', () => show(index - 1))
  elements.next.addEventListener('click', () => show(index + 1))

  const single = images.length < 2
  elements.prev.hidden = single
  elements.next.hidden = single
  elements.counter.hidden = single

  document.body.appendChild(overlay)
}

function open(i) {
  if (!overlay) build()

  opener = document.activeElement
  overlay.hidden = false
  document.body.style.overflow = 'hidden'
  show(i)
  overlay.focus()
}

function close() {
  if (!overlay || overlay.hidden) return

  overlay.hidden = true
  document.body.style.overflow = ''
  if (opener instanceof HTMLElement) opener.focus()
  opener = null
}

// 両端で止める。端まで来たらボタンを効かなくする。
function show(i) {
  index = Math.min(Math.max(i, 0), images.length - 1)
  const image = images[index]

  elements.image.src = image.dataset.lightboxSrc || image.currentSrc || image.src
  elements.image.alt = image.alt
  elements.prev.disabled = index === 0
  elements.next.disabled = index === images.length - 1
  elements.counter.textContent = `${index + 1} / ${images.length}`
}

function onKeydown(event) {
  if (!overlay || overlay.hidden) return

  if (event.key === 'Escape') close()
  else if (event.key === 'ArrowLeft') show(index - 1)
  else if (event.key === 'ArrowRight') show(index + 1)
  else return

  event.preventDefault()
}
